import { render, staticRenderFns } from "./FreeDivision.vue?vue&type=template&id=a5f20f70"
import script from "./FreeDivision.vue?vue&type=script&lang=js"
export * from "./FreeDivision.vue?vue&type=script&lang=js"
import style0 from "./FreeDivision.vue?vue&type=style&index=0&id=a5f20f70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports